<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">用户系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>注册登录实名开关</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="item">
        <span>登录(包括重置找回密码登录)支持中国大陆用户</span>
        <el-switch style="display: block" v-model="dataInfo.login" active-text="开" inactive-text="关" @change="changeLogin($event, 'LOGIN')"></el-switch>
      </div>
      <div class="item">
        <span>注册支持中国大陆用户</span>
        <el-switch style="display: block" v-model="dataInfo.register" active-text="开" inactive-text="关" @change="changeRegister($event, 'REGIST')"></el-switch>
      </div>
      <div class="item">
        <span>实名认证支持中国大陆用户</span>
        <el-switch style="display: block" v-model="dataInfo.kyc" active-text="开" inactive-text="关" @change="changeKyc($event, 'KYC')"></el-switch>
      </div>
    </el-card>
  </div>
</template>
<script>
import api from "./api";
export default {
  data() {
    return {
      dataInfo: {
        login: false,
        register: false,
        kyc: false
      }
    };
  },
  methods: {
    getInfo() {
      api.getAuthApplyCount().then(res => {
        this.dataInfo = res.data
      });
    },
    changeLogin(val, type) {
      this.dataInfo.login = val
      this.update(type, val)
    },
    changeRegister(val, type) {
      this.dataInfo.register = val
      this.update(type, val)
    },
    changeKyc(val, type) {
      this.dataInfo.kyc = val
      this.update(type, val)
    },
    update(type, status) {
      let data = {
        id: this.dataInfo.id,
        type: type,
        status: status
      }
      api.updateZHStatus(data).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      })
    }
  },
  created() {
    this.getInfo();
  }
};
</script>
<style lang="less" scoped>
.item {
  margin-bottom: 20px;
  span {
    display: block;
    margin-bottom: 10px;
  }
}
</style>